import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

import Footer from "./components/footer/Footer";
//import Topbar from "./components/topbar/Topbar";
import Aboutus from "./pages/aboutuspage/Aboutus";
//import Navbar from './components/navbar/Navbar'; <Navbar />
import Homepage from "./pages/homepage/Homepage";
import Contactus from "./pages/contactuspage/Contactus";
import Services from "./pages/servicespage/Services";
import Navbarmenu from './components/thirdnav/Navbarmenu';

function App() {
  return (
    <div className="App">
      <Router>

        <Navbarmenu />

        <div className="routescontainer">
          <Routes>

            <Route exact path="/" element={<Homepage />} />
            <Route exact path="/home" element={<Homepage />} />
            <Route exact path="/services" element={<Services />} />
            <Route exact path="/contactus" element={<Contactus />} />
            <Route exact path="/aboutus" element={<Aboutus />} />


          </Routes>
        </div>
      </Router>
      <Footer />
    </div>
  );
}

export default App;







